<template>
  <div class="m-3">
    <div class="row col-12 d-flex justify--space-between mb-2">
      <span class="card-text-bold"> {{title}} </span>
    </div>
    <table>
      <tr>
        <td v-for="key in columns" class="card-text-bold">
          <div class="d-flex align-items-center h-100 table-div-header">
            {{key}}
          </div>
        </td>
      </tr>
      <tr v-for="elem in rawData">
        <td v-for="(key, index) in columns" class="card-text-normal">
          {{elem[index]}}
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import moment from 'moment';

export default {
  name: "DataTable",
  props: {
    type: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    data: {
      type: Array,
      required: true
    }
  },
  data: () => {
    return {}
  },
  computed: {
    rawData: function () {
      if(this.type === 'referenceValues') {
        return this.data
      } else if (this.type === 'historic') {
        let data = []
        //console.log(this.data)
        this.data.forEach(elem => {
          data.push([moment(elem.timestamp).format('YYYY/MM/DD'), ...elem.data])
        })
        return data
      }
      return []
    }
  }
}
</script>

<style scoped lang="scss">
table {
  width: 100%;
  height: 100%;
  table-layout: fixed;
  color: #23292E;
}

td {
  padding-left: 12px;
  height: 100%;
}

tr {
  height: 50px;

}

.table-div-header {

}

tr:first-child {
  background: #e1e1e1;
  td:first-child {
    border-top-left-radius: 20px;
  }
  td:last-child {
    border-top-right-radius: 20px;
  }
}

</style>
